"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Grid = exports.CellRoot = void 0;
const react_1 = __importStar(require("react"));
const fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
const components_1 = require("@veeam/components");
require("@veeam/components/lib/Toolbar");
require("@veeam/components/lib/Grid/types");
const constants_1 = require("../../constants");
require("../../core");
const utils_1 = require("../../helpers/utils");
const cellRenderers_1 = require("./cellRenderers");
const helpers_1 = require("./helpers");
const Layouts_1 = require("./Layouts");
const toolbarGridDecorators_1 = require("./toolbarGridDecorators");
const types_1 = require("./types");
const useContextMenu_1 = require("./useContextMenu");
function CellRoot({ colProps, cellProps, }) {
    const cellContent = colProps.cell
        ? colProps.cell(Object.assign({}, cellProps))
        : cellRenderers_1.textWithEmptyCellRenderer({
            emptyValue: constants_1.EMPTY_TEXT.dash,
            headerJustify: colProps.headerJustify,
        })(Object.assign({}, cellProps));
    if (colProps.headerJustify === components_1.GRID_COLUMN_HEADER_JUSTIFY.right) {
        return react_1.default.createElement("div", { style: { width: '100%', textAlign: 'right' } }, cellContent);
    }
    return react_1.default.createElement(react_1.default.Fragment, null, cellContent);
}
exports.CellRoot = CellRoot;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function Grid({ id, data, columns, toolbar, contextMenu, contextMenuDecorator = (menuItems, payload) => {
    return menuItems.map((item) => {
        var _a;
        return (Object.assign(Object.assign({}, item), { disabled: !((_a = payload === null || payload === void 0 ? void 0 : payload.selectedItems) === null || _a === void 0 ? void 0 : _a.length) || !!(payload === null || payload === void 0 ? void 0 : payload.loading) }));
    });
}, idKey = 'rowIndex', selectionMod = types_1.GRID_SELECTION_MOD.single, onSelect = utils_1.noop, onSelectionChange = utils_1.noop, selected: selectedIds, hasHeader = true, height = components_1.GRID_HEIGHT_MODE.auto, loading, disabled, toolbarDecorator = toolbarGridDecorators_1.toolbarGridDecorators.simple(), rowHeight, toggleable, sort: gridSort, sorting = utils_1.noop, pagination, getCellProps = (props) => props, showCheckbox = true, totalRow, resizable, isIndeterminateSelected = false, onRowDoubleClick = utils_1.noop, isRowDisabled, rowContainerRenderer, subheaderRenderer, texts, }) {
    var _a, _b;
    const idAccessorFn = helpers_1.idAccessor(idKey, data);
    const prevData = react_1.useRef(data);
    const prevSelectedIds = react_1.useRef(selectedIds);
    const [selected, setSelected] = react_1.useState(helpers_1.computeSelected(data, selectedIds !== null && selectedIds !== void 0 ? selectedIds : [], idAccessorFn));
    const [sort, setSort] = react_1.useState({
        direction: (gridSort === null || gridSort === void 0 ? void 0 : gridSort.orderAsc) !== null
            ? (gridSort === null || gridSort === void 0 ? void 0 : gridSort.orderAsc)
                ? components_1.GRID_SORT_DIRECTIONS.asc
                : components_1.GRID_SORT_DIRECTIONS.desc
            : null,
        key: (_a = gridSort === null || gridSort === void 0 ? void 0 : gridSort.orderColumn) !== null && _a !== void 0 ? _a : null,
    });
    react_1.useEffect(() => {
        var _a;
        if (gridSort) {
            setSort({
                direction: (gridSort === null || gridSort === void 0 ? void 0 : gridSort.orderAsc) !== null
                    ? (gridSort === null || gridSort === void 0 ? void 0 : gridSort.orderAsc)
                        ? components_1.GRID_SORT_DIRECTIONS.asc
                        : components_1.GRID_SORT_DIRECTIONS.desc
                    : null,
                key: (_a = gridSort === null || gridSort === void 0 ? void 0 : gridSort.orderColumn) !== null && _a !== void 0 ? _a : null,
            });
        }
    }, [gridSort === null || gridSort === void 0 ? void 0 : gridSort.orderAsc, gridSort === null || gridSort === void 0 ? void 0 : gridSort.orderColumn]);
    react_1.useLayoutEffect(() => {
        if (prevData.current === data && fast_deep_equal_1.default(prevSelectedIds.current, selectedIds)) {
            return;
        }
        prevData.current = data;
        prevSelectedIds.current = selectedIds;
        setSelected(helpers_1.computeSelected(prevData.current, prevSelectedIds.current || [], idAccessorFn));
    });
    const rows = data.map((item, idx) => (Object.assign(Object.assign({}, item), { rowIndex: idx })));
    const toolbarItems = (toolbar || []).filter(Boolean);
    const [contextMenuControl, { show: showContextMenu }] = useContextMenu_1.useContextMenu({
        items: (_b = contextMenuDecorator === null || contextMenuDecorator === void 0 ? void 0 : contextMenuDecorator(contextMenu !== null && contextMenu !== void 0 ? contextMenu : [], {
            selectedItems: selected,
            loading,
        })) !== null && _b !== void 0 ? _b : (contextMenu !== null && contextMenu !== void 0 ? contextMenu : []).filter(Boolean),
    });
    const onRowContextMenuProps = (contextMenu === null || contextMenu === void 0 ? void 0 : contextMenu.length)
        ? {
            onRowContextMenu: ({ nativeEvent }) => {
                if (!disabled && !loading && (contextMenu === null || contextMenu === void 0 ? void 0 : contextMenu.length)) {
                    nativeEvent.preventDefault();
                    showContextMenu({ offsetX: nativeEvent.pageX, offsetY: nativeEvent.pageY });
                }
            },
        }
        : {};
    const GridContent = (react_1.default.createElement(components_1.Grid, Object.assign({ data: rows, hideHeader: !hasHeader, height: typeof height === 'number' ? components_1.GRID_HEIGHT_MODE.auto : height, rowHeight: rowHeight, sort: sort, pagination: pagination, totalRow: totalRow, toggleable: toggleable, resizable: resizable, selection: {
            field: idKey,
            multiple: selectionMod === types_1.GRID_SELECTION_MOD.multi,
            checkbox: selectionMod === types_1.GRID_SELECTION_MOD.multi && showCheckbox,
            selected: selected,
            fullLength: data.length,
            isSelectedAll: !!selected.length && selected.length === data.length,
            isIndeterminate: isIndeterminateSelected && !!selected.length && selected.length !== data.length,
            subheaderRenderer,
        }, onSelectionChange: ({ selected: selectedItems }) => {
            setSelected(selectedItems);
            onSelect === null || onSelect === void 0 ? void 0 : onSelect(selectedItems);
            onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange(selectedItems.map(idAccessorFn));
        }, onHeaderSelectionChange: (selectedAll) => {
            setSelected(selectedAll ? data : []);
            onSelect === null || onSelect === void 0 ? void 0 : onSelect(selectedAll ? data : []);
            onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange(selectedAll ? data.map(idAccessorFn) : []);
        }, onRowDoubleClick: onRowDoubleClick, isRowDisabled: isRowDisabled, rowContainerRenderer: rowContainerRenderer, texts: texts }, onRowContextMenuProps), columns.filter(Boolean).map(({ field, title, width, minWidth, cell, headerCell, hidden, headerJustify, totalColumn, onHeaderClick, sortable, }) => (react_1.default.createElement(components_1.GridColumn, Object.assign({ key: field }, {
        field,
        title,
        width,
        minWidth,
        hidden,
        headerJustify,
        totalColumn,
        onHeaderClick: sortable ? () => sorting(field) : onHeaderClick,
        headerCell,
    }, { cell: (props) => {
            const newProps = getCellProps(props);
            return (react_1.default.createElement(CellRoot, { colProps: {
                    field,
                    title,
                    width,
                    headerJustify,
                    cell,
                    hidden,
                    onHeaderClick,
                    sortable,
                }, cellProps: newProps }));
        } }))))));
    return (react_1.default.createElement(Layouts_1.GridRoot, { "data-selector-id": id },
        toolbarItems &&
            !!toolbarItems.length &&
            toolbarDecorator(toolbarItems, { selectedItems: selected, loading }),
        react_1.default.createElement(Layouts_1.GridBody, { height: typeof height === 'number' ? height : undefined },
            disabled && react_1.default.createElement(components_1.Overlay, { view: components_1.OVERLAY_VIEW.soft, contentMod: components_1.OVERLAY_CONTENT_MOD.center }),
            GridContent,
            loading && !disabled && (react_1.default.createElement(components_1.Overlay, { view: components_1.OVERLAY_VIEW.soft, contentMod: components_1.OVERLAY_CONTENT_MOD.center },
                react_1.default.createElement(components_1.Spinner, { size: constants_1.SPINNER_SIZES.xxl })))),
        contextMenuControl));
}
exports.Grid = Grid;
Grid.displayName = 'Grid';
//# sourceMappingURL=Grid.js.map